export const tabs = [
  { id: 21, name: "Uthmani" },
  { id: 22, name: "Indo-Pak" },
  { id: 23, name: "Tajweed" },
];
